import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useState, useEffect } from 'react';
import Clipboard from 'clipboard';
import _ from 'lodash';
import { Toast, Loading, Modal as ZaModal } from 'zarm';
import ZaToast from '@/components/ZaToast';
import { getState, dispatch } from '@/store';
import { goNext, jumpPage } from '@/utils/navigation';
import { getQueryParam, getHashParam } from '@/utils/tool';
import request from '@/utils/request';
import { PLAN_ID, FETCH_STORE } from '@/constants';
import SingleAlert from '@/components/SingleAlert/singleAlert';
import { getPage, findModuleFromPage } from '@/utils/utils';
/* eslint-disable import/prefer-default-export */

function createForm(attrs, values) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.enctype = 'application/x-www-form-urlencoded';
  Object.keys(attrs).forEach(key => {
    form.setAttribute(key, attrs[key]);
  });
  Object.keys(values).forEach(key => {
    const input = document.createElement('input');
    input.name = key;
    input.value = values[key];
    input.type = 'hidden';
    form.appendChild(input);
  });
  form.style.display = 'none';
  document.body.appendChild(form);
  return {
    submit() {
      form.submit();
    },

    destroy() {
      document.body.removeChild(form);
    }

  };
}

const cacheStore = {};

const debounceRequest = (...args) => {
  const key = args.reduce((res = '', arg = '') => {
    const partKey = typeof arg === 'object' ? JSON.stringify(arg) : arg;
    return `${res}${partKey}`;
  }, 'debounce - ');

  if (!cacheStore[key]) {
    cacheStore[key] = request(...args).then((res = {}) => {
      cacheStore[key] = undefined;
      return res;
    }).catch(e => {
      cacheStore[key] = undefined;
      throw e;
    });
  }

  return cacheStore[key];
};

const toArray = (list = []) => {
  return Array.isArray(list) ? list : [list];
};

const getOrderData = () => {
  const fetchStore = getState(FETCH_STORE) || {};
  const queryParams = getQueryParam() || {}; // 如果是告知列表页添加标识符

  const notificationModule = findModuleFromPage(module => {
    return module.component === 'healthNotificationListModule';
  });
  return _objectSpread(_objectSpread(_objectSpread({}, fetchStore), queryParams), {}, {
    needAllInsured: true // !!notificationModule

  });
};

export const useEventCallback = fn => {
  const ref = useRef(fn);
  ref.current = fn;
  return (...args) => {
    const {
      current
    } = ref;
    return current && current(...args);
  };
}; // 获取本地事件处理函数

export const getLocalClick = (opts = {}, middlewares = []) => {
  middlewares = toArray(middlewares) || [];

  if (!opts) {
    return;
  }

  const {
    type = '',
    link = '',
    modal = '',
    behavior = '',
    copyText = '',
    page = []
  } = opts;

  const localClick = () => {
    switch (type) {
      case 'link':
        {
          window.location.href = link;
          break;
        }

      case 'page':
        {
          const [pageId, moduleId, tabIndex] = page;
          const currentPage = Number(getState('currentPage'));
          const curr = getPage(pageId) || {};
          const {
            pageOrder
          } = curr;

          if (pageOrder === currentPage) {
            const element = document.getElementById(moduleId);

            if (!element) {
              return;
            }

            if (getState(`module${moduleId}`)) {
              getState(`module${moduleId}`).show();
              getState(`module${moduleId}`).setTab(Number(tabIndex));
              return;
            }

            const tab = document.getElementsByClassName('c-AnchorTabsComponents-tabs')[0];

            if (tab) {
              const a = element.getBoundingClientRect().top;
              const tabT = tab.getBoundingClientRect().top;
              const b = document.documentElement.getBoundingClientRect().top;

              if (a > tabT) {
                document.documentElement.scrollTop = a - b - 50;
                document.body.scrollTop = a - b - 50;
              } else {
                document.documentElement.scrollTop = a - b;
                document.body.scrollTop = a - b;
              }
            } else {
              const a = element.getBoundingClientRect().top;
              const b = document.documentElement.getBoundingClientRect().top;
              document.documentElement.scrollTop = a - b - 50;
              document.body.scrollTop = a - b - 50;
            }
          } else {
            goNext(pageOrder);
          }

          break;
        }

      case 'modal':
        {
          const modalObj = getState(`component_${modal}`);
          modalObj && modalObj.show();
          break;
        }

      case 'closeModal':
        {
          const modalObj = getState(`component_${modal}`);
          modalObj.hide();
          break;
        }

      case 'behavior':
        {
          if (behavior === 'copyAndOpenWechat') {
            const dom = document.createElement('div');
            dom.classList.add('behavior-copy-text');
            dom.setAttribute('data-clipboard-text', copyText);
            document.body.appendChild(dom); // eslint-disable-next-line no-new

            new Clipboard('.behavior-copy-text');
            dom.click();
            setTimeout(() => {
              window.location.href = 'weixin://';
            }, 0);
          } else if (behavior === 'cancel') {
            const modalObj = getState(`component_${modal}`);
            modalObj && modalObj.hide();
          } else if (behavior === 'close') {
            const modalObj = getState(`component_${modal}`);
            modalObj && modalObj.hide();
          }

          break;
        }

      default:
        console.warn(`按钮不支持${type}的操作`);
        break;
    }
  };

  return middlewares.reduceRight((next, middleware) => {
    return middleware(opts, next);
  }, localClick);
};
export const useLocalClick = (...args) => {
  const localClick = getLocalClick(...args);
  return useEventCallback(localClick);
}; // 获取订单数据

export const getOrderDetail = async () => {
  const planId = getState(PLAN_ID);
  const data = getOrderData() || {};
  const {
    orderNo,
    thirdOrderNo
  } = data;
  const currentUrl = window.location.href; // baseData

  if (orderNo || thirdOrderNo) {
    var _res$result;

    const opts = {
      method: 'POST',
      data
    };
    const res = (await request('/v1/insure/queryOrderDetail', opts)) || {};
    const {
      code,
      message,
      result = {}
    } = res;

    if (Number(code) || !res.success) {
      Toast.show(message || '网络异常，请稍后重试');
      return;
    } // 详情存入extraInfo


    dispatch('extraInfo', res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.extraInfo);
    dispatch('orderDetail', result); // handleNoticeQuestion(res.result);

    return _objectSpread(_objectSpread({}, result), {}, {
      currentUrl,
      planId
    });
  }
}; // 流程接口调用

export const fetchClick = async (data = {}, middlewares = []) => {
  middlewares = toArray(middlewares);
  const queryParams = getQueryParam() || {}; // 智能核保跳回时投保流程时 fetch_store被清空, 这时需要取地址栏上的订单号和加密订单号

  if (queryParams.orderNo) {
    data.orderNo = queryParams.orderNo;
    data.encryptOrderNo = queryParams.encryptOrderNo;
  }

  const nextOrderDetail = await getOrderDetail();

  const _premium = getState('premium');

  data.insuredList.forEach((item, inIndex) => {
    var _nextOrderDetail$insu, _nextOrderDetail$insu2, _nextOrderDetail$insu3, _nextOrderDetail$insu4, _item$packageList;

    item.allowInsure = nextOrderDetail === null || nextOrderDetail === void 0 ? void 0 : (_nextOrderDetail$insu = nextOrderDetail.insuredList) === null || _nextOrderDetail$insu === void 0 ? void 0 : (_nextOrderDetail$insu2 = _nextOrderDetail$insu[inIndex]) === null || _nextOrderDetail$insu2 === void 0 ? void 0 : _nextOrderDetail$insu2.allowInsure;
    item.selected = nextOrderDetail === null || nextOrderDetail === void 0 ? void 0 : (_nextOrderDetail$insu3 = nextOrderDetail.insuredList) === null || _nextOrderDetail$insu3 === void 0 ? void 0 : (_nextOrderDetail$insu4 = _nextOrderDetail$insu3[inIndex]) === null || _nextOrderDetail$insu4 === void 0 ? void 0 : _nextOrderDetail$insu4.selected;
    (_item$packageList = item.packageList) === null || _item$packageList === void 0 ? void 0 : _item$packageList.forEach((packItem, packIndex) => {
      var _packItem$productList;

      // // 新增
      // packItem.initialPremium = _premium.initialPremium;
      (_packItem$productList = packItem.productList) === null || _packItem$productList === void 0 ? void 0 : _packItem$productList.forEach((proItem, proIndex) => {
        const {
          productCode
        } = proItem;
        proItem === null || proItem === void 0 ? void 0 : proItem.liabilityList.forEach((liaItem, liaIndex) => {
          var _nextOrderDetail$insu5;

          const {
            liabilityCode
          } = liaItem;
          nextOrderDetail === null || nextOrderDetail === void 0 ? void 0 : (_nextOrderDetail$insu5 = nextOrderDetail.insuredList) === null || _nextOrderDetail$insu5 === void 0 ? void 0 : _nextOrderDetail$insu5.forEach((detailInsuredItem, detailInsuredIndex) => {
            detailInsuredItem === null || detailInsuredItem === void 0 ? void 0 : detailInsuredItem.packageList.forEach((detailPackItem, detailPackIndex) => {
              detailPackItem === null || detailPackItem === void 0 ? void 0 : detailPackItem.productList.forEach((detailProItem, detailProIndex) => {
                detailProItem === null || detailProItem === void 0 ? void 0 : detailProItem.liabilityList.forEach((detailLiaItem, detailLiaIndex) => {
                  var _item$person, _detailInsuredItem$pe;

                  const packFlag = detailPackItem.packageCode === packItem.packageCode;
                  const personFlag = ((_item$person = item.person) === null || _item$person === void 0 ? void 0 : _item$person.certNo) === ((_detailInsuredItem$pe = detailInsuredItem.person) === null || _detailInsuredItem$pe === void 0 ? void 0 : _detailInsuredItem$pe.certNo);
                  const productFlag = productCode === detailProItem.productCode;
                  const liaFlag = liabilityCode === detailLiaItem.liabilityCode;
                  const sumFlag = packFlag && personFlag && productFlag && liaFlag;

                  if (sumFlag) {
                    liaItem.sumInsuredString = detailLiaItem.sumInsuredString;
                  }
                });
              });
            });
          });
        }); // const _insuredList = getState('premium.insuredList')

        if (_premium !== null && _premium !== void 0 && _premium._insuredList) {
          _premium === null || _premium === void 0 ? void 0 : _premium._insuredList.forEach((pItem, pIndex) => {
            var _pItem$packageResultL;

            (_pItem$packageResultL = pItem.packageResultList) === null || _pItem$packageResultL === void 0 ? void 0 : _pItem$packageResultL.forEach((packPItem, packPIndex) => {
              var _packPItem$productRes;

              (_packPItem$productRes = packPItem.productResultList) === null || _packPItem$productRes === void 0 ? void 0 : _packPItem$productRes.forEach((proPItem, proPIndex) => {
                if (productCode === proPItem.productCode) {
                  const {
                    initialPremium,
                    amount
                  } = proPItem;
                  proItem.premium = initialPremium;
                  proItem.sumInsured = amount;
                }
              });
            });
          });
        } else {// proItem.premium = _premium.initialPremium;
          // proItem.sumInsured = amount;
        }
      });
    });
  });
  const opts = {
    method: 'POST',
    data
  };
  const {
    iseebiz
  } = window;
  const purchaseUserId = queryParams === null || queryParams === void 0 ? void 0 : queryParams.purchaseUserId;
  const thirdOrderNo = queryParams === null || queryParams === void 0 ? void 0 : queryParams.thirdOrderNo;
  const thirdOrderNoType = queryParams === null || queryParams === void 0 ? void 0 : queryParams.thirdOrderNoType;
  const insuredExtension = queryParams === null || queryParams === void 0 ? void 0 : queryParams.insuredExtension;

  if (iseebiz) {
    data.extraInfo.iseeBiz = iseebiz; // 接入千里眼可回溯
  }

  if (purchaseUserId) {
    data.extraInfo.purchaseUserId = purchaseUserId; // 华米登录id
  }

  if (thirdOrderNo) {
    data.extraInfo.thirdOrderNo = thirdOrderNo; // 第三方登录信息
  }

  if (thirdOrderNoType) {
    data.extraInfo.thirdOrderNoType = thirdOrderNoType; // 第三方登录信息
  }

  if (insuredExtension) {
    data.extraInfo.insuredExtension = insuredExtension; // 第三方扩展字段
  }

  Loading.show();
  const res = (await debounceRequest('/v1/insure/nextStep', opts)) || {};
  Loading.hide();
  const {
    code,
    message,
    success,
    result
  } = res || {};

  if (!success || Number(code)) {
    const codeList = ['20000', '20019'];

    if (codeList.includes(code)) {
      const modal = SingleAlert({
        title: '温馨提示',
        content: message,
        onCancel: () => {
          modal.hide();
        }
      });
      return;
    }

    Toast.show(message || '网络异常，请稍后重试');
    return;
  }

  const {
    pageActionList = []
  } = result || {};
  pageActionList.forEach((item = {}) => {
    const {
      pageAction,
      data: _data = {}
    } = item;
    const {
      message: dataMessage,
      url,
      formData,
      pageCode,
      encryptOrderNo,
      orderNo
    } = _data || {};

    const runAction = () => {
      switch (pageAction) {
        case 'updateOrderNo':
          {
            // const fetchStore = getState(FETCH_STORE) || {};
            // dispatch(FETCH_STORE, { ...fetchStore, ...data });
            break;
          }

        case 'alert':
          {
            const modal = SingleAlert({
              title: '温馨提示',
              content: dataMessage,
              onCancel: () => {
                modal.hide();
              }
            });
            break;
          }

        case 'jumpToUrl':
          {
            window.location.href = url;
            break;
          }

        case 'formSubmit':
          {
            const _data1 = formData ? JSON.parse(formData) : _data;

            const form = createForm({
              action: url,
              method: 'POST'
            }, _data1);
            form.submit();
            break;
          }

        case 'jumpToPage':
          {
            const curr = getPage(pageCode) || {};
            const {
              pageOrder
            } = curr; // goNext(pageOrder);

            if (encryptOrderNo) {
              jumpPage(pageOrder, {
                encryptOrderNo,
                orderNo
              });
            } else {
              jumpPage(pageOrder);
            }

            break;
          }

        case 'none':
        default:
          break;
      }
    };

    middlewares.reduceRight((next, middleware) => {
      return middleware(item, next);
    }, runAction)();
  });
}; // 根据告知类型获取告知

export const useNotice = noticeObjectType => {
  const [notice, setNotice] = useState({});
  const planId = getState(PLAN_ID);
  useEffect(() => {
    const fn = async () => {
      if (!planId) {
        return;
      } // eslint-disable-next-line no-undef


      const data = (await getFetchData()) || {};
      const {
        certNo
      } = getHashParam() || {};
      if (certNo) data.extraInfo.currentInsuredFlag = certNo;
      const opts = {
        method: 'POST',
        data: _objectSpread(_objectSpread({}, data), {}, {
          planId,
          noticeObjectType
        })
      };
      const res = (await request('/v1/insure/queryNoticeQuestion', opts)) || {};
      const {
        code,
        message,
        result = {}
      } = res;

      if (Number(code)) {
        ZaToast.show(message || '系统异常，请稍后重试');
        return;
      }

      setNotice(result);
    };

    fn();
  }, [planId]);
  return [notice, setNotice];
};